import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/ErrorEntity";
import SearchResultEntity from "../../../../domain/entities/SearchResultEntity";
import ShiftEntity from "../../../../domain/entities/ShiftEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import ShiftDto from "../../../dto/ShiftDto";

const SearchShiftsApiImpl = async (query: string | undefined, page: number, itemsPerPage: number): Promise<Either<ErrorEntity, SearchResultEntity<ShiftEntity>>> => {
    try {
        // turns/searcher?date=2025-10-29&text=bad bunny
        let relativeUrl = `/turns/searcher?page=${page}&per_page=${itemsPerPage}${query ? `&text=${encodeURIComponent(query)}` : ''}`;
        if(query != undefined && query.length > 0){
            relativeUrl += `&query=${encodeURIComponent(query)}`;
        }
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        
        const shifts = response.turns.map((item: any) => ShiftDto.fromJSON(item));
        
        const result: SearchResultEntity<ShiftEntity> = {
            data: shifts,
            total: response.pagination.total,
            page: response.pagination.current_page,
            itemsPerPage: response.pagination.per_page,
            pages: response.pagination.last_page,
        };
        
        return right(result);
    } catch (e) {
        return left({ code: "Error" });
    }
}

export default SearchShiftsApiImpl;